import applicantsList from './components/applicantsList.vue';

export default {
  routes: [
    {
      path: '/',
      component:applicantsList,
      name:'applicantsList'
    }
  ]
};
